import React, { useState } from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import MaterialTable from 'material-table';
import { Paper } from '@material-ui/core'; 

import { formatCurrency } from '../../utils/currencyFormatter';
import { getAdditionalServiceName } from '../../utils/additionalServices';
import { paymentMethodMap } from '../../utils/paymentMethodMap';
import { IconButton, Tooltip } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import ConfirmationDialog from '../confirmation/ConfirmationDialog';


import style from './awbInfo.module.css';
import commonStyles from '../common/common.module.css';
import PaymentAwbInfo from '../../models/PaymentAwbInfo';

const styles = (theme: Theme) =>

  createStyles({

  });


interface AwbPaymentInfoComponentProps {
  classes: any;
  paymentInfo: Array<PaymentAwbInfo>;
  deleteManifestCharge?: (isConfirmed?: boolean) => void;
};

const awbIPaymentInfoComponent = (props: AwbPaymentInfoComponentProps) => {
  const { classes } = props;
  const [showConfirm, setShowConfirm] = useState(false);
  const [isConfirmedCharge, setIsConfirmedCharge] = useState(false);

  const handleDeleteClick = (statusConfirmed: boolean) => {
    setIsConfirmedCharge(statusConfirmed);
    setShowConfirm(true);
  };

  const executeDelete = () => {
    setShowConfirm(false);
    if (props.deleteManifestCharge) {
      props.deleteManifestCharge(isConfirmedCharge);
    }
  };

  return (
    <div className={ `${ commonStyles.wrapper } ${ style.wrapper }` }>
      <h3 className={ `${ commonStyles.header } ` } >Payment Information</h3>
      <div className={ style.inputsWrapper } >

        <MaterialTable

          components={{Container: props => <Paper {...props} elevation={0} className={ commonStyles.paperTable }/>}}
          
          data={ props.paymentInfo }

          columns={[
            { title: 'Forwarder', render: (rowData: PaymentAwbInfo) => {
              return <span>{rowData.first_name}-{rowData.last_name}</span>;
            }},

            { title: 'Fee', render: (rowData: any) => {
              return (
                <div className={style.feeName}>
                  {getAdditionalServiceName(rowData.service)}:
                  {rowData.service === 'other' ? ' ' + rowData.params.reason : ''}
                </div>
              )
            }},

            { title: 'Amount', render: (rowData: PaymentAwbInfo) => {
              return (
                <div className={style.dueRow}>
                  <div>$</div>
                  <div>{formatCurrency(rowData.amount, 2)}</div>
                </div>
              )
            }},

            { title: 'Payment Source', field: '', render: (rowData: PaymentAwbInfo) => {
              return (
                <div>{ paymentMethodMap[`${rowData.payment_type_name }`]}</div>
              )
            }},
            { title: ' Status', field: 'status' },
            { title: ' Payment Info', field: 'payment_info' },
            {
              title: 'Actions',
              render: (rowData: PaymentAwbInfo) => {
                if (rowData.service === 'certified_manifest_charge') {
                  return (
                    <Tooltip title="Delete Charge">
                      <IconButton onClick={() => handleDeleteClick(rowData.status === 'confirmed')} size="small">
                        <DeleteOutlineIcon color="error" />
                      </IconButton>
                    </Tooltip>
                  );
                }
                return null;
              }
            }
          ]}

          options={{
            selection: false,
            paging: false,
            pageSize: 10,
            headerStyle: {
              backgroundColor: 'var(--tbl_head_bkg)',
              color: 'var(--tbl_head_color)',
              zIndex: 2,
            },
            showTitle: false,
            pageSizeOptions: [15, 20],
            toolbar: false,
            sorting: false,
          }}
        />
        <ConfirmationDialog
          open={showConfirm}
          title={"Delete Charge"}
          text={"Are you sure you want to delete this charge?"}
          close={() => setShowConfirm(false)}
          confirm={executeDelete}
          textConfirm={"Delete"}
          textCancel={"Cancel"}
          showCloseIcon={true}
          showCancelButton={true}
        />
      </div>

    </div>

  );
};

export default withStyles(styles)(awbIPaymentInfoComponent);